import { render } from "./InquiryListPage.vue?vue&type=template&id=3b5aab26"
import script from "./InquiryListPage.vue?vue&type=script&lang=js"
export * from "./InquiryListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__